import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
/**
 * Returns all (non-section) children from a nested array of content.
 * Useful to determine the total count of content within a section.
 */

export function getAllContentChildren(items) {
  return items.flatMap(function (item) {
    if (item.type === 'section') {
      return getAllContentChildren(item.children);
    } else {
      return item;
    }
  });
}